import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';

@Service()
export default class SupportPaymentTransactionService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;
    public async get(
        invoiceNumber: string,
        senderName: string,
        displayId: string,
        provider: string,
        paymentReference: string,
        pageIndex: string,
        pageSize: string
    ): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const params = new URLSearchParams({
                invoiceNumber,
                senderName,
                displayId,
                provider,
                paymentReference,
                pageIndex,
                pageSize
            });

            const url = `${window.$config.HostName}api/payment-transaction/get-all-for-support?${params.toString()}`;
            const result = await this.axiosService.axiosInstance.get(url);
            return result.data;
        } catch (error) {
            return false;
        } finally {
            this.loaderService.HideLoader();
        }
    }
}
